export const FETCH_CONTACT_TYPES_REQUEST =
  'contactTypes/FETCH_CONTACT_TYPES_REQUEST'
export const FETCH_CONTACT_TYPES_SUCCESS =
  'contactTypes/FETCH_CONTACT_TYPES_SUCCESS'
export const FETCH_CONTACT_TYPES_FAILURE =
  'contactTypes/FETCH_CONTACT_TYPES_FAILURE'

export const FETCH_CONTACT_TYPE_REQUEST =
  'contactTypes/FETCH_CONTACT_TYPE_REQUEST'
export const FETCH_CONTACT_TYPE_SUCCESS =
  'contactTypes/FETCH_CONTACT_TYPE_SUCCESS'
export const FETCH_CONTACT_TYPE_FAILURE =
  'contactTypes/FETCH_CONTACT_TYPE_FAILURE'

export const DELETE_CONTACT_TYPE_REQUEST =
  'contactTypes/DELETE_CONTACT_TYPE_REQUEST'
export const DELETE_CONTACT_TYPE_SUCCESS =
  'contactTypes/DELETE_CONTACT_TYPE_SUCCESS'
export const DELETE_CONTACT_TYPE_FAILURE =
  'contactTypes/DELETE_CONTACT_TYPE_FAILURE'

export const CREATE_CONTACT_TYPE_REQUEST =
  'contactTypes/CREATE_CONTACT_TYPE_REQUEST'
export const CREATE_CONTACT_TYPE_SUCCESS =
  'contactTypes/CREATE_CONTACT_TYPE_SUCCESS'
export const CREATE_CONTACT_TYPE_FAILURE =
  'contactTypes/CREATE_CONTACT_TYPE_FAILURE'

export const UPDATE_CONTACT_TYPE_REQUEST =
  'contactTypes/UPDATE_CONTACT_TYPE_REQUEST'
export const UPDATE_CONTACT_TYPE_SUCCESS =
  'contactTypes/UPDATE_CONTACT_TYPE_SUCCESS'
export const UPDATE_CONTACT_TYPE_FAILURE =
  'contactTypes/UPDATE_CONTACT_TYPE_FAILURE'

export const UPDATE_FIELD = 'contactTypes/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'contactTypes/SET_DEFAULT_DATA'
